import * as XLSX from '@e965/xlsx'

interface generateExcelFileProps {
  headers?: (string | number)[]
  rows?: Record<string, any>[]
  title?: string
}

export const generateExcelFile = ({
  headers = [],
  rows = [],
  title = '',
}: generateExcelFileProps) => {
  // Extract headers from the first row if headers array is empty
  const derivedHeaders =
    headers.length === 0 && rows.length > 0 ? Object.keys(rows[0]) : headers

  const worksheet = XLSX.utils.json_to_sheet(rows)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Default')
  XLSX.utils.sheet_add_aoa(worksheet, [derivedHeaders], { origin: 'A1' })
  XLSX.writeFile(workbook, `${title}.xlsx`)
}
